export default function Video({ room }) {
  const src = `https://meet.jit.si/${encodeURIComponent(room)}#config.prejoinPageEnabled=false&config.disableDeepLinking=true`;
  return (
    <div className="videobox" data-testid="video-room">
      <iframe
        title="video-consultation"
        src={src}
        allow="camera; microphone; fullscreen; display-capture; autoplay"
      />
    </div>
  );
}
